/**
 * Kiosk time helpers — replicated from mobile for parity.
 * The backend may send UTC timestamps with or without a trailing `Z`; treat them as UTC regardless.
 */

/** Treat a backend timestamp as UTC: append `Z` if missing, then parse. */
export const parseUtcTimestamp = (value: string) => {
  const normalised = value.endsWith('Z') ? value : `${value}Z`;
  return new Date(normalised);
};

/** UTC ISO string → device-local `HH:mm` (24h, zero-padded). */
export const formatTime = (value: string) => {
  const date = parseUtcTimestamp(value);
  if (Number.isNaN(date.getTime())) return '';
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

/**
 * Elapsed time since `startTimeUtc` as `HH:mm:ss`. Hours accumulate (can exceed 99, e.g. `3248:11:48`).
 * `now` is injectable (defaults to `Date.now()`) so the live counter can pass its ticking clock.
 */
export const formatElapsedTime = (startTimeUtc: string, now: number = Date.now()) => {
  const startMs = parseUtcTimestamp(startTimeUtc).getTime();
  if (Number.isNaN(startMs)) return '';
  const elapsedMs = Math.max(0, now - startMs);
  const totalSeconds = Math.floor(elapsedMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
